import { render, staticRenderFns } from "./HPagination.vue?vue&type=template&id=bbe2df96&scoped=true&"
import script from "./HPagination.vue?vue&type=script&lang=js&"
export * from "./HPagination.vue?vue&type=script&lang=js&"
import style0 from "./HPagination.vue?vue&type=style&index=0&id=bbe2df96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe2df96",
  null
  
)

export default component.exports